import { render } from "./AddMIllsModal2.vue?vue&type=template&id=3e95f832&scoped=true"
import script from "./AddMIllsModal2.vue?vue&type=script&lang=js"
export * from "./AddMIllsModal2.vue?vue&type=script&lang=js"

import "./AddMIllsModal2.vue?vue&type=style&index=0&id=3e95f832&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e95f832"]])

export default __exports__